import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/geschaeftsarten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="BusinessTypes"
      returnRoute="/auswahlfelder/businessTypes"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const BusinessTypesRoute = Route;
